import { isBuildAborted, isBuildRunning, isRecentlyFinished, PublicApiBuild, RemoteAccessData } from '@/models/Build';

const isRemoteAccessInstructionsVisible = (build: PublicApiBuild, remoteAccessData?: RemoteAccessData): boolean => {
  if (!remoteAccessData) {
    return false;
  }

  if (isRecentlyFinished(build)) {
    return !isBuildAborted(build);
  }

  return isBuildRunning(build);
};

export default isRemoteAccessInstructionsVisible;
